import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { NavLink } from 'react-router-dom';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, CampoData } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IFileListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineFile;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class FileLista extends BaseComponent<Glob.IRouteGlobaleProps, IFileListaState> {

    private ParametriFissi: Dati.TListaParametri = {};
    private ID_Chiave: number;

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        this.ID_Chiave = (this.props.match.params as any).ID_Chiave;
        this.ParametriFissi["ID_Chiave"] = this.ID_Chiave.toString();
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        this.OnChange = this.OnChange.bind(this);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [0, 7], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 1:
                                this.OnOrdinamento("TipoFile", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("NomeFile", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("NumeroDocumento", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("TipoFileStato", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 5:
                                this.OnOrdinamento("UtenteAnag", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 6:
                                this.OnOrdinamento("Modificato", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }
    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineFile, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={8} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr data-row="0" key={dato.ID_File}>
                        <td data-field="TipoFile" className="TextCenter"><NavLink className="arrow" to={"/api/file/scarica?id_file=" + dato.ID_File + "&sessione=" + Glob.GetSessione().Sessione} target="_blank"><i className={Glob.RestituisciIcona(dato.MIME)}></i></NavLink></td>
                        <td data-field="TipoFile" className="TextLeft">{dato.TipoFile}</td>
                        <td data-field="NomeFile" className="TextLeft">{dato.NomeFile}</td>
                        <td data-field="NumeroDocumento" className="TextLeft">{dato.NumeroDocumento}</td>
                        <td data-field="TipoFileStato" className="TextLeft">{dato.TipoFileStato}</td>
                        <td data-field="UtenteAnag" className="TextLeft">{dato.UtenteAnag}</td>
                        <td data-field="Modificato" className="TextCenter">{Trad.Trad(dato.Modificato)}</td>
                        <td data-field="edit" className="TextCenter">
                            <a href={"/file/" + this.ID_Chiave + "/" + dato.ID_File} className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" onClick={(e) => { e.preventDefault(); this.props.history.push("/file/" + this.ID_Chiave + "/" + dato.ID_File) }}>
                                <i className="la la-edit"></i>
                            </a>
                        </td>
                    </tr>)}
            </tbody >;
        }
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={8}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-file"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Documenti")}</h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                            <NavLink to={"/file/" + this.ID_Chiave + "/0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                <i className="fa fa-plus"></i>
                            </NavLink>
                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Testo")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={(e) => this.OnChange(e)} type="text" value={this.state.ParametriUtente["Testo"] || ""} name="ParametriUtente[Testo]" className="form-control kt-input" />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("UtenteAnag")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input id="ParametriUtente[UtenteAnag]" name="ParametriUtente[UtenteAnag]" value={this.state.ParametriUtente["UtenteAnag"]} onChange={this.OnChange} type="text" className="form-control kt-input" />
                        </div>
                        <label className="col-lg-1 col-form-label">
                            {Trad.Trad("TipoFile")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo Campo="ParametriUtente[ID_TipoFile]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoFile"] || ""} OnAggiorna={this.OnChange} URL="/api/Tipi/ListaTipi?ID_TipoContesto=File" />
                            </div>
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <label className="col-lg-1 col-form-label">
                            {Trad.Trad("TipoFileStati")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo IgnoraPermessi Campo="ParametriUtente[ID_TipoFileStato]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoFileStato"] || ""} OnAggiorna={this.OnChange} URL="/api/Tipi/ListaTipi?ID_TipoContesto=FileStati" />
                            </div>
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("DataValidita")}</label>
                        <div className="col-lg-3 form-control-plaintext"> <div className="form-control">
                            <CampoData ValoreInArrivo={false}
                                Name="ParametriUtente[Data]"
                                Id="ParametriUtente[Data]"
                                Valore={this.state.ParametriUtente["Data"]}
                                OnChange={this.OnChange} /></div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="col kt-form__actions kt-form__actions--center">
                        <div className="row">
                            <div className="col-lg-12 kt--align-center">
                                <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
            <div>
                <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                    <thead>
                        <tr className="sfondoTab">
                            <th data-field="TipoFile" className="TextCenter">{Trad.Trad("Visualizza")}</th>
                            <th data-field="TipoFile" className="TextLeft">{Trad.Trad("TipoFile")}</th>
                            <th data-field="NomeFile" className="TextLeft">{Trad.Trad("NomeFile")}</th>
                            <th data-field="NumeroDocumento" className="TextLeft"> {Trad.Trad("Numero documento")}</th>
                            <th data-field="TipoFileStato" className="TextLeft"> {Trad.Trad("TipoFileStato")}</th>
                            <th data-field="UtenteAnag" className="TextLeft"> {Trad.Trad("UtenteAnag")}</th>
                            <th data-field="Modificato" className="TextCenter"> {Trad.Trad("Modificato")}</th>
                            <th data-field="Modificato" className="TextCenter"> {Trad.Trad("Modifica")}</th>
                        </tr>
                    </thead>
                    <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/file/ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreLista} />
                </table>
            </div>
            <div className="kt-portlet__foot">
                <div className="row align-items-center">
                    <div className="col-lg-12 kt--align-right">
                        <button type="button" className="btn btn-warning" onClick={() => this.props.history.goBack()} title={Trad.Trad("Indietro")}> {Trad.Trad("Indietro")}</button>
                    </div>
                </div>
            </div>
        </div >;
    }
}



// WEBPACK FOOTER //
// ./src/form/FileLista.tsx